import * as React from 'react';

import { COLORS } from '@clutter/clean';

import { Stats } from '@shared/page_builder/components/stats';

interface BusinessStatsProps {
  background?: string;
  textColor?: string;
  descriptionFontSize?: string;
  maxWidth?: string;
}

const BusinessStats: React.FC<BusinessStatsProps> = ({
  background = COLORS.dust,
  textColor = COLORS.tealDark,
  descriptionFontSize,
  maxWidth,
}) => (
  <div>
    <Stats
      background={background}
      textColor={textColor}
      descriptionFontSize={descriptionFontSize}
      maxWidth={maxWidth}
      stats={[
        { value: '50,000', description: 'Customers served nationwide' },
        { value: '7.5 million', description: 'Items stored' },
        { value: '92%', description: 'Customer satisfaction' },
      ]}
    />
  </div>
);

export { BusinessStats };
